import React from 'react';
import { Plus, Search } from 'lucide-react';

interface EmptyStateProps {
  type: 'no-pipelines' | 'no-results';
  onCreateFirst?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ type, onCreateFirst }) => {
  if (type === 'no-pipelines') {
    return (
      <div
        className="bg-white dark:bg-gray-800 rounded-lg shadow p-12 text-center"
        data-testid="empty-state-no-pipelines"
      >
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/20 mb-4">
          <Plus className="w-8 h-8 text-blue-600 dark:text-blue-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
          No pipelines yet
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">
          Get started by creating your first pipeline. Pipelines define the workflow steps that
          process your requirements into code.
        </p>
        {onCreateFirst && (
          <button
            onClick={onCreateFirst}
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            data-testid="create-first-button"
          >
            <Plus className="w-5 h-5" />
            Create First Pipeline
          </button>
        )}
      </div>
    );
  }

  // no-results
  return (
    <div
      className="bg-white dark:bg-gray-800 rounded-lg shadow p-12 text-center"
      data-testid="empty-state-no-results"
    >
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-700 mb-4">
        <Search className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
        No pipelines match your filters
      </h3>
      <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
        Try adjusting your search query or filters to find what you're looking for.
      </p>
    </div>
  );
};

